import * as React from 'react';
import { ISvgAtomProps } from './Atoms.interfaces';
import { useContainerWidth } from '../hooks/useContainerWidth';

const ProductCoupons: React.FC<ISvgAtomProps> = ({ width = 180, height = 30, fullWidth = false }) => {
  const { ref: svgRef, width: containerWidth } = useContainerWidth(fullWidth, width);

  const displayWidth = fullWidth ? '100%' : width;
  const viewBoxWidth = fullWidth ? containerWidth : width;

  return (
    <svg
      ref={svgRef as React.LegacyRef<SVGSVGElement>}
      x={0}
      y={0}
      width={displayWidth}
      height={height}
      viewBox={`0 0 ${viewBoxWidth} ${height}`}
    >
      <rect
        x={0}
        y={0}
        width={viewBoxWidth}
        height={height}
        rx={4}
        fill="#fff"
        stroke="#d6d6d6"
        strokeDasharray="5,5"
      />
      <text
        x={viewBoxWidth / 2}
        y={height / 2}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="#7a7a7a"
        fontSize={10}
      >
        Clip coupon
      </text>
    </svg>
  );
};

export default ProductCoupons;
